import HuaweiError from '../../../../controllers/HuaweiErrors';
import { PlayResult } from '../../../../interfaces';
import {
  AuthorizationFailedError,
  GeoBlockedError,
  MaxPlaybackSessionsError,
  NotAllowedError,
  NotSubscribedError,
  UnknownPlayerError,
} from '../error';

export function handlePlayResult(data: PlayResult) {
  if (data.retcode === HuaweiError.GEO_BLOCKED) {
    throw new GeoBlockedError();
  }

  if (data.retcode === HuaweiError.MAX_PLAYBACK_SESSIONS) {
    throw new MaxPlaybackSessionsError(data.retcode, data.retmsg);
  }

  if (data.retcode === HuaweiError.NOT_ALLOWED) {
    throw new NotAllowedError();
  }

  if (data.retcode === HuaweiError.AUTHORIZATION_FAILED) {
    throw new AuthorizationFailedError();
  }

  if (data.retcode === HuaweiError.NOT_SUBSCRIBED) {
    throw new NotSubscribedError();
  }

  if (data.retcode !== '0') {
    throw new UnknownPlayerError(data.retcode, data.retmsg);
  }

  return data;
}
